export default () =>{
    const iconsWithHover = document.querySelectorAll('[data-icon-hover]')

    iconsWithHover.forEach(item=>{
        item.addEventListener('mouseover',e=>{
            e.currentTarget.style.backgroundColor = e.currentTarget.dataset.iconHover
            e.currentTarget.style
        })
        item.addEventListener('mouseout',e=>{
            e.currentTarget.style.backgroundColor = e.currentTarget.dataset.iconBackground
        })
    })
}